<template>
  <svg viewBox="0 0 24 24" v-on="$listeners">
    <g fill="currentColor">
      <path
        d="M11.64 5.23a1 1 0 0 0-1.41.13l-5 6a1 1 0 0 0 0 1.27l4.83 6a1 1 0 0 0 .78.37a1 1 0 0 0 .78-1.63L7.29 12l4.48-5.37a1 1 0 0 0-.13-1.4z"
      ></path>
      <path
        d="M14.29 12l4.48-5.37a1 1 0 0 0-1.54-1.28l-5 6a1 1 0 0 0 0 1.27l4.83 6a1 1 0 0 0 .78.37a1 1 0 0 0 .78-1.63z"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'arrow-first',
}
</script>